var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.263,
    height: 6.931,
    viewBox: "0 0 10.263 6.931",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3148",
    "data-name": "Group 3148",
    transform: "translate(1.131 1.131)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3149",
    "data-name": "Group 3149"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8489",
    "data-name": "Path 8489",
    d: "M13.364,6.818l-5.091,5L5.364,8.961",
    transform: "translate(-5.364 -6.818)",
    fill: "none",
    stroke: "#16161a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.a45a828f6a5ae0294fd0bfa75c05dd31.svg";
export { ForwardRef as ReactComponent };